module.exports = __webpack_public_path__ + "static/media/second.eab92359.jpg";